export default __webpack_public_path__ + "static/media/surface.37babbf4.jpg";